module.exports = __webpack_public_path__ + "static/img/anos_60.71a93dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_60.png
// module id = A3Zr
// module chunks = 0